<template>
  <div>
    <h3 class="mb-2">
      <strong>Delivery Method</strong>
    </h3>

    <b-form-group>
      <b-form-radio-group
        v-model="formStore.formData.deliveryMethod"
        class="checkbox-group"
        :options="deliveryOptions"
        stacked
      />
    </b-form-group>

    <div class="d-flex justify-content-between mt-4">
      <b-button
        variant="light"
        @click="formStore.prevStep"
      >
        BACK
      </b-button>
      <b-button
        variant="primary"
        :disabled="!formStore.formData.deliveryMethod"
        @click="formStore.nextStep"
      >
        NEXT
      </b-button>
    </div>
  </div>
</template>

<script>
import { useFormStore } from "../stores/formStore";
import { useStyleStore } from "../stores/styleStore";

export default {
  components: {},
  data() {
    return {
      formStore: useFormStore(),
      styleStore: useStyleStore(),
      
    };
  },
  computed:{
    deliveryOptions(){
      const styleStore = useStyleStore();
      const allowed = styleStore.onlineVoucherSettings?.allowed_delivery_types || [];
      //all options
      const allOptions = [
        {
          text: "Printable - Get a beautifully formatted Gift Voucher, ready to print. We'll also email you a backup.",
          value: "printable",
        },
        {
          text: "Email - We email the Gift Voucher to you, or to your gift recipient.",
          value: "email",
        },
        {
          text: "Scheduled Email - You pick when the voucher gets delivered.",
          value: "scheduledEmail",
        },
        {
          text: `Postal (${styleStore.storeInfo.currency} 5.00 each) - We mail your purchase in our card stock elegant format print material.`,
          value: "postal",
        },
      ]
      
      return allowed.length ? allOptions.filter(o => allowed.includes(o.value)) : allOptions;
    },    
  },
  mounted() {
   
  }
};
</script>

<style>
.checkbox-group {
  padding-top: 25px;
}
.checkbox-group .form-check {
  margin-bottom: 15px !important;
}
</style>
